import { useEffect } from 'react';
import { walletAPI } from '../services/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function usePushNotifications() {
  useEffect(() => {
    const register = async () => {
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
      if (Notification.permission === 'denied') return;

      try {
        const reg = await navigator.serviceWorker.ready;
        const existing = await reg.pushManager.getSubscription();
        if (existing) {
          await walletAPI.subscribePush(existing.toJSON());
          return;
        }

        if (Notification.permission === 'default') {
          const perm = await Notification.requestPermission();
          if (perm !== 'granted') return;
        }

        const res = await walletAPI.getVapidKey();
        const key = urlBase64ToUint8Array(res.data.public_key);
        const sub = await reg.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: key
        });
        await walletAPI.subscribePush(sub.toJSON());
      } catch (err) {
        console.log('Push registration failed:', err);
      }
    };

    // Delay to not interfere with page load
    const timer = setTimeout(register, 3000);
    return () => clearTimeout(timer);
  }, []);
}
